// TelcoTrack — Věcná břemena: formátování textu (port n8n).

const TITLE_STANDARD: [RegExp, string][] = [
  [/^ing\.?$/i, 'Ing.'],
  [/^mgr\.?$/i, 'Mgr.'],
  [/^judr\.?$/i, 'JUDr.'],
  [/^ph\.?d\.?$/i, 'Ph.D.'],
  [/^csc\.?$/i, 'CSc.'],
  [/^drsc\.?$/i, 'DrSc.'],
  [/^mba\.?$/i, 'MBA'],
];

/** Právní formy / zkratky — nesmí se Title-Casovat na „A.s.“ / „S.r.o.“. */
const LEGAL_FORM_STANDARD: [RegExp, string][] = [
  [/^a\.?\s*s\.?$/i, 'a.s.'],
  [/^s\.?\s*r\.?\s*o\.?$/i, 's.r.o.'],
  [/^spol\.?\s*s\.?\s*r\.?\s*o\.?$/i, 'spol. s r.o.'],
  [/^v\.?\s*o\.?\s*s\.?$/i, 'v.o.s.'],
  [/^k\.?\s*s\.?$/i, 'k.s.'],
  [/^s\.?\s*p\.?$/i, 's.p.'],
  [/^o\.?\s*p\.?\s*s\.?$/i, 'o.p.s.'],
  [/^z\.?\s*s\.?$/i, 'z.s.'],
];

/**
 * Spojky a krátké předložky uprostřed jména — n8n/CETIN očekává „a“ mezi manželi,
 * ne Title-Case „A“ (např. „Jaroslav Kočí a Jana Kočí“).
 */
const LOWERCASE_MID_TOKENS = new Set([
  'a',
  'i',
  'nebo',
  'či',
  's',
  'z',
  'v',
  'u',
  'k',
  'o',
  'na',
  'do',
  'od',
  'po',
  'za',
  'ke',
  've',
  'ze',
  'se',
  'pro',
  'při',
  'nad',
  'pod',
  'před',
  'mezi',
]);

function formatWordTitleCase(word: string, isFirstToken: boolean): string {
  for (const [re, std] of TITLE_STANDARD) {
    if (re.test(word)) return std;
  }
  for (const [re, std] of LEGAL_FORM_STANDARD) {
    if (re.test(word)) return std;
  }
  const stripped = word.replace(/^[„"'(]+|[„"')]+$/g, '');
  if (!isFirstToken && LOWERCASE_MID_TOKENS.has(stripped.toLocaleLowerCase('cs-CZ'))) {
    const lower = stripped.toLocaleLowerCase('cs-CZ');
    return word.replace(stripped, lower);
  }
  const lowered = word.replace(/[A-Z\u00C0-\u017F]/g, (ch) => ch.toLocaleLowerCase('cs-CZ'));
  return lowered.replace(/[a-z\u00C0-\u017F]/, (ch) => ch.toLocaleUpperCase('cs-CZ'));
}

/** Převod HŮLKOVÉHO písma na Title Case (port n8n `krasneJmeno`). */
export function krasneJmeno(text: string): string {
  if (!text) return text;
  let isFirstToken = true;
  return text
    .split(/(\s+|-|,)/)
    .map((part) => {
      if (part === '-' || part === ',' || /^\s+$/.test(part)) {
        if (part === '-' || part === ',') isFirstToken = true;
        return part;
      }
      const formatted = formatWordTitleCase(part, isFirstToken);
      isFirstToken = false;
      return formatted;
    })
    .join('');
}

export function trimOrEmpty(value: string | null | undefined): string {
  return (value ?? '').trim();
}
